import * as React from "react";
import { Modernizations } from "../../calcBusterTypes";
import { Table } from "@amzn/awsui-components-react";
import { USDollar } from "../../util";

const ModernizationsDetails = (modernizations: Modernizations) => {
  const items = modernizations.paths;
  return (
    <Table
      columnDefinitions={[
        {
          id: "name",
          header: "Name",
          cell: (item) => item.name,
          sortingField: "name",
        },
        {
          id: "annualRunRate",
          header: "annualRunRate",
          cell: (item) => USDollar.format(item.annualRunRate),
          sortingField: "annualRunRate",
        },
      ]}
      items={items}
      variant="embedded"
      sortingDisabled
    />
  );
};

export default ModernizationsDetails;
